import {
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
} from "../../actions/formulaAction";
import { useDispatch, useSelector } from "react-redux";

const RawToGranularForNonClinicPopup = ({
  closePopup,
  isRawType,
  setPacketsPerDay,
  setDays,
  setScoops,
  setTimePerDay,
  scoops,
  days,
  packetsPerDay,
  timePerDay,
  overallTotal,
  totalPacket,
  setRawGram,
  prepMethod,
  requireServing,
  setIsConverted,
  rawGramPerDayBeforeConversion,
  preparationMethods,
  setPrepMethod,
}) => {
  const dispatch = useDispatch();
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const prescriptionFormFields = useSelector(
    (state) => state.settings.prescriptionFormFields
  );
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const [firstTime, setFirstTime] = useState(true);
  const [localScoops, setLocalScoops] = useState(0);
  const [localTimePerDay, setLocalTimePerDay] = useState(0);
  const [localDays, setLocalDays] = useState(0);
  const [localPrepMethod, setLocalPrepMethod] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const getDosageToChange = (desiredGranularTotal) => {
    let existingGranularTotal = 0;

    // Calculate existing granular total from formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from formula herbs
      });
    });

    // Calculate existing granular total from single herbs
    singleHerbList.forEach((herb) => {
      existingGranularTotal += herb.dosageInFloat; // Sum up the dosage from single herbs
    });

    // Calculate additional granular needed
    let additionalGranularNeeded = desiredGranularTotal - existingGranularTotal;

    // Calculate total raw amount needed based on ratios
    let totalRawNeeded = 0;

    // Calculate raw amounts for formulas
    formulas.forEach((formula) => {
      formula.formulaHerbs.forEach((herb) => {
        let rawAmount =
          (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1;
        rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
        totalRawNeeded +=
          (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
      });
    });

    // Calculate raw amounts for single herbs
    singleHerbList.forEach((herb) => {
      let rawAmount =
        (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1;
      rawAmount = Number.isNaN(rawAmount) ? 0 : rawAmount;
      totalRawNeeded +=
        (rawAmount * additionalGranularNeeded) / existingGranularTotal; // Distributing the additional granular needed
    });

    // Add existing raw amounts to total needed
    const totalExistingRawAmount =
      formulas.reduce((total, formula) => {
        return (
          total +
          formula.formulaHerbs.reduce(
            (sum, herb) =>
              sum +
              (isNaN(
                (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ??
                1
              )
                ? 0
                : (herb.dosageInFloat * herb.rawRatio ?? 5) /
                herb.granularUnit ?? 1),
            0
          )
        );
      }, 0) +
      singleHerbList.reduce(
        (total, herb) =>
          total +
          (isNaN(
            (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ?? 1
          )
            ? 0
            : (herb.dosageInFloat * herb.rawRatio ?? 5) / herb.granularUnit ??
            1),
        0
      );

    return totalExistingRawAmount + totalRawNeeded;
  };

  useEffect(() => {
    if (localPrepMethod) {
      if (firstTime) {
        setLocalScoops(
          Math.round(
            localPrepMethod?.id == 5
              ? localScoops * (2 * prescriptionFormFields.scoopSize)
              : localScoops
          )
        );
        setFirstTime(false);
      } else {
        setLocalScoops(
          Math.round(
            localPrepMethod?.id == 5
              ? localScoops * (2 * prescriptionFormFields.scoopSize)
              : localScoops / (2 * prescriptionFormFields.scoopSize)
          )
        );
      }
    }
  }, [localPrepMethod]);

  useEffect(() => {
    setRawGram();
  }, []);

  useEffect(() => {
    if (rawGramPerDayBeforeConversion > 0) {
      setLocalTimePerDay(2);
      const raw = parseFloat(rawGramPerDayBeforeConversion);
      const scoops = Math.ceil(raw / (2 * prescriptionFormFields?.scoopSize));
      setLocalScoops(scoops);
    }
  }, [rawGramPerDayBeforeConversion]);

  const handleConvert = () => {
    if (localPrepMethod == null) {
      setErrorMessage("Please select a preparation method.");
      return;
    }
    if (localScoops <= 0 || localTimePerDay <= 0 || localDays <= 0) {
      setErrorMessage("All fields are required and must be greater than 0.");
      return;
    }

    dispatch(changeFormulaTypeFromDays(false, 1));
    // setRawGram();
    setScoops(localScoops);
    setTimePerDay(localTimePerDay);
    setDays(localDays);
    setPrepMethod(localPrepMethod);
    setErrorMessage("");
    setIsConverted(true);
    // dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
    // dispatch(
    //   changeFormulaType(
    //     true,
    //     getDosageToChange(
    //       parseFloat(localScoops * localDays * localTimePerDay)
    //     ),
    //     null,
    //     true
    //   )
    // );
    // dispatch(changeFormulaTypeFromDays(false, 1));
    closePopup();
  };

  const handleValidNumberInput = (value) => {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed < 0 ? 0 : parsed;
  };

  return (
    <Modal show={true} id="prescription-popup" size="xl">
      <Modal.Body>
        <div className="prescription-detail">
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
          <div className="inner-section">
            <h2 className="heading">Servings</h2>
            <p className="desc">
              The daily therapeutic dosage in granular for this formula is{" "}
              {rawGramPerDayBeforeConversion}g/day. This is the number of grams
              in granular that is equivalent to 1 packet of raw herbs. Please
              choose a preparation method and we will approximate the servings
              for you. Please enter the number of days you would like to
              prescribe this formula to proceed. You can change these numbers
              anytime here, or on the next page.{" "}
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 200, hide: 100 }}
                overlay={
                  <Tooltip id="prescription-tooltip">
                    <p style={{ textAlign: "left" }}>
                      We have solved one of herbal medicine’s biggest
                      challenges: granular herb dosing.
                      <br /> <br /> ✅ Quality Herbs are no longer granulated at
                      a universal 5:1 ratio. Different
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;concentrations are now
                      used to optimize potency and quality. This makes
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;converting herbs from
                      raw to granular very difficult.
                      <br /> <br /> ✅ “3 scoops twice daily” serving
                      instructions is outdated and inaccurate. Each
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;formula has a unique
                      therapeutic dose (grams/day). Some formulas maybe 2
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;scoops and another 10
                      scoops per day.
                      <br /> <br /> ✅ Dosage vs. Dosing: <br /> <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosage = amount in
                      grams per herb in a formula.
                      <br /> <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosing (therapeutic
                      dose) = how much of the finished formula to be taken per
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;day. In Raw the
                      standard daily dose of a formula is 1 Packet per day
                      whereas in &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;granular it
                      is the number of grams per day (needs to be calculated).
                      <br /> <br />
                      ⭐Start by writing your formulas in RAW, and MHP will
                      auto-convert to granular AND
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;provide the
                      recommended daily therapeutic dose! This is a huge leap
                      for our &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;industry—and
                      we’re proud to lead the way. <br /> <br />
                    </p>
                  </Tooltip>
                }
              >
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{ cursor: "pointer" }}
                />
              </OverlayTrigger>
            </p>
            <div className="wrapper">
              <table className="table" style={{ background: "white" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "40px" }}></td>
                    <td>
                      <b>Preparation Method</b>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className="">
                      <label>
                        <>
                          <div className="prep-method">
                            {preparationMethods
                              ?.filter((x) => x.isRaw == 0 && x.status)
                              .map((x) => {
                                return (
                                  <div key={x.id} className="mb-3 text-left ">
                                    <label>
                                      {x.prepMethod}
                                      <input
                                        style={{ marginLeft: "10px" }}
                                        type="radio"
                                        checked={localPrepMethod?.id == x.id}
                                        onChange={() => {
                                          setLocalPrepMethod(x);
                                          setErrorMessage("");
                                        }}
                                        name="prepMethod"
                                      />
                                    </label>
                                    <br />
                                  </div>
                                );
                              })}
                          </div>
                        </>
                      </label>
                    </td>
                    <td></td>

                    <td></td>
                    <td></td>

                    <td></td>
                    <td></td>
                    <td></td>

                    <td></td>
                  </tr>
                  <tr className={localPrepMethod ? "" : "darken"}>
                    <td style={{ width: "40px" }}></td>
                    <td>
                      <b>Serving Instructions</b>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr className={localPrepMethod ? "" : "darken"}>
                    <th></th>
                    <th>
                      <label style={{ marginBottom: 0, color: "#626262" }}>
                        Serving Size
                      </label>
                    </th>
                    <th></th>
                    <th>
                      <label style={{ marginBottom: 0, color: "#626262" }}>
                        Frequency
                      </label>
                    </th>
                    <th></th>
                    <th>
                      <label style={{ marginBottom: 0, color: "#626262" }}>
                        Duration
                      </label>
                    </th>
                    <th></th>
                    <th>
                      <label style={{ marginBottom: 0, color: "#626262" }}>
                        Daily Dosage
                      </label>
                    </th>
                    <th>
                      <label style={{ marginBottom: 0, color: "#626262" }}>
                        Total Grams
                      </label>
                    </th>
                  </tr>
                  <tr style={{ height: "120px" }} className={localPrepMethod ? "" : "darken"}>
                    <td></td>
                    {/* Scoops */}
                    <td
                      className="number-field-wrapper"
                      style={{ position: "relative" }}
                    >
                      <div
                        className={`number-field ${localScoops <= 0 || !localPrepMethod
                          ? "border border-danger"
                          : ""
                          }`}
                      >
                        <input
                          value={localPrepMethod ? localScoops : 0}
                          type="number"
                          min={0}
                          disabled={!localPrepMethod}
                          onChange={(e) => {
                            if (localPrepMethod == null) {
                              setErrorMessage(
                                "Please select a preparation method."
                              );
                            } else {
                              setLocalScoops(
                                handleValidNumberInput(e.target.value)
                              );
                              setErrorMessage("");
                            }
                          }}
                        />
                        <div>
                          <div
                            className="icon"
                            disabled={!localPrepMethod}
                            style={{
                              cursor: localPrepMethod
                                ? "pointer"
                                : "not-allowed",
                              background: localPrepMethod
                                ? "white"
                                : "#DDDDDD",
                            }}
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalScoops(localScoops + 1);
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon" style={{
                              cursor: localPrepMethod
                                ? "pointer"
                                : "not-allowed",
                              background: localPrepMethod
                                ? "white"
                                : "#DDDDDD",
                            }}
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalScoops(
                                  localScoops > 0 ? localScoops - 1 : 0
                                );
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                        <p
                          className="ml-1 "
                          style={{
                            fontSize: "14px",
                            position: "absolute",
                            top: "75%",
                          }}
                        >
                          {localPrepMethod?.id == 1
                            ? `(1 scoop = ${prescriptionFormFields?.scoopSize} grams)`
                            : localPrepMethod?.id == 5
                              ? "(1 capsule = 0.5 grams)"
                              : localPrepMethod?.id == 6
                                ? "Tablets"
                                : ""}
                        </p>
                      </div>
                      <p className="ml-1 mt-1">
                        {localPrepMethod?.id == 1
                          ? "Scoops"
                          : localPrepMethod?.id == 5
                            ? "Capsules"
                            : localPrepMethod?.id == 6
                              ? "Tablets"
                              : ""}
                      </p>
                    </td>

                    <td className="text-center"></td>

                    {/* Frequency */}
                    <td className="number-field-wrapper">
                      <div
                        className={`number-field ${localTimePerDay <= 0 || !localPrepMethod
                          ? "border border-danger"
                          : ""
                          }`}
                      >
                        <input
                          type="number"
                          min={0}
                          disabled={!localPrepMethod}
                          value={localPrepMethod ? localTimePerDay : 0}
                          onChange={(e) => {
                            if (localPrepMethod == null) {
                              setErrorMessage(
                                "Please select a preparation method."
                              );
                            } else {
                              setLocalTimePerDay(
                                handleValidNumberInput(e.target.value)
                              );
                              setErrorMessage("");
                            }
                          }}
                        />
                        <div>
                          <div style={{
                            cursor: localPrepMethod
                              ? "pointer"
                              : "not-allowed",
                            background: localPrepMethod
                              ? "white"
                              : "lightgray",
                          }}
                            className="icon"
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalTimePerDay(localTimePerDay + 1);
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon"
                            style={{
                              cursor: localPrepMethod
                                ? "pointer"
                                : "not-allowed",
                              background: localPrepMethod
                                ? "white"
                                : "#DDDDDD",
                            }}
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalTimePerDay(
                                  localTimePerDay > 0 ? localTimePerDay - 1 : 0
                                );
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </div>
                      <p className="ml-1 mt-1" style={{ marginBottom: 0 }}>
                        Time(s) per day
                      </p>
                    </td>

                    <td className="text-center"></td>

                    {/* Days */}
                    <td className="number-field-wrapper">
                      <div
                        className={`number-field ${localDays <= 0 ? "border border-danger" : ""
                          }`}
                      >
                        <input
                          type="number"
                          min={0}
                          disabled={!localPrepMethod}
                          value={localDays}
                          onChange={(e) => {
                            if (localPrepMethod == null) {
                              setErrorMessage(
                                "Please select a preparation method."
                              );
                            } else {
                              setLocalDays(
                                handleValidNumberInput(e.target.value)
                              );
                              setErrorMessage("");
                            }
                          }}
                        />
                        <div>
                          <div
                            className="icon" style={{
                              cursor: localPrepMethod
                                ? "pointer"
                                : "not-allowed",
                              background: localPrepMethod
                                ? "white"
                                : "#DDDDDD",
                            }}
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalDays(localDays + 1);
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretUp} />
                          </div>
                          <div
                            className="icon"
                            style={{
                              cursor: localPrepMethod
                                ? "pointer"
                                : "not-allowed",
                              background: localPrepMethod
                                ? "white"
                                : "#DDDDDD",
                            }}
                            onClick={() => {
                              if (localPrepMethod == null) {
                                setErrorMessage(
                                  "Please select a preparation method."
                                );
                              } else {
                                setLocalDays(localDays > 0 ? localDays - 1 : 0);
                                setErrorMessage("");
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </div>
                      <p className="ml-1 mt-1" style={{ marginBottom: 0 }}>
                        Day(s)
                      </p>
                    </td>

                    <td className="text-center"></td>

                    {/* Daily Dosage */}
                    <td>
                      <b>
                        {(
                          (localPrepMethod ? localScoops : 0) *
                          localTimePerDay *
                          (localPrepMethod?.id === 5
                            ? 0.5
                            : prescriptionFormFields?.scoopSize)
                        ).toFixed(1)}{" "}
                        grams
                      </b>
                    </td>

                    {/* Total Grams */}
                    <td>
                      <b>
                        {(
                          (localPrepMethod ? localScoops : 0) *
                          localTimePerDay *
                          localDays *
                          (localPrepMethod?.id === 5
                            ? 0.5
                            : prescriptionFormFields?.scoopSize)
                        ).toFixed(1)}{" "}
                        grams
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {errorMessage ? (
              <div className="text-danger">{errorMessage}</div>
            ) : (
              <div style={{ color: "#333" }}> no </div>
            )}
          </div>

          {/* 🔧 Error Message */}

          {/* Submit */}
          <div className="submit-section d-flex justify-content-end">
            <button className="btn-orange" onClick={handleConvert}>
              Convert
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RawToGranularForNonClinicPopup;
